import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import Header from '../Layout/Header';

const TermsOfService: React.FC = () => {
  return (
    <Box>
      <Header />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={1} sx={{ p: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: 'primary.main' }}>
            利用規約
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            最終更新日: 2024年12月
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第1条（適用）
            </Typography>
            <Typography variant="body1" paragraph>
              本規約は、DeckWin（以下「当サービス」）が提供するカードゲーム対戦記録サービスの利用に関して、当サービスと利用者との間の権利義務関係を定めることを目的とし、利用者と当サービスとの間に成立する契約です。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第2条（利用登録）
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスの利用を希望する者は、本規約に同意の上、当サービスの定める方法によって利用登録を申請し、当サービスがこれを承認することによって、利用登録が完了するものとします。
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">利用登録の申請に際して虚偽の事項を届け出た場合</Typography>
              <Typography component="li" variant="body1">本規約に違反したことがある者からの申請である場合</Typography>
              <Typography component="li" variant="body1">その他、当サービスが利用登録を相当でないと判断した場合</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第3条（アカウント管理）
            </Typography>
            <Typography variant="body1" paragraph>
              利用者は、自己の責任において、当サービスのアカウント情報を適切に管理するものとします。
            </Typography>
            <Typography variant="body1" paragraph>
              利用者は、アカウント情報が盗用されたり第三者に使用されたりしないよう、自己の責任において適切に管理し、これらの管理を怠った場合は、当サービスに一切の責任を負わせないものとします。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第4条（サービス内容）
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、以下の機能を提供します：
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">カードゲーム対戦記録の登録・管理</Typography>
              <Typography component="li" variant="body1">デッキ情報の管理</Typography>
              <Typography component="li" variant="body1">勝率統計の表示・分析</Typography>
              <Typography component="li" variant="body1">フォーマット管理</Typography>
              <Typography component="li" variant="body1">その他関連する機能</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第5条（禁止事項）
            </Typography>
            <Typography variant="body1" paragraph>
              利用者は、当サービスの利用にあたり、以下の行為をしてはなりません。
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">法令または公序良俗に違反する行為</Typography>
              <Typography component="li" variant="body1">犯罪行為に関連する行為</Typography>
              <Typography component="li" variant="body1">当サービスの内容等、当サービスに含まれる著作権、商標権その他の知的財産権を侵害する行為</Typography>
              <Typography component="li" variant="body1">当サービス、ほかの利用者、またはその他第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</Typography>
              <Typography component="li" variant="body1">当サービスによって得られた情報を商業的に利用する行為</Typography>
              <Typography component="li" variant="body1">当サービスの運営を妨害するおそれのある行為</Typography>
              <Typography component="li" variant="body1">不正アクセスをし、またはこれを試みる行為</Typography>
              <Typography component="li" variant="body1">その他、当サービスが不適切と判断する行為</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第6条（利用制限および登録抹消）
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、利用者が以下のいずれかに該当する場合には、事前の通知なく、投稿データを削除し、当該利用者について当サービスの全部もしくは一部の利用を制限し、または利用登録を抹消することができるものとします。
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">本規約のいずれかの条項に違反した場合</Typography>
              <Typography component="li" variant="body1">登録事項に虚偽の事実があることが判明した場合</Typography>
              <Typography component="li" variant="body1">当サービスからの連絡に対し、一定期間返答がない場合</Typography>
              <Typography component="li" variant="body1">当サービスについて、最終の利用から一定期間利用がない場合</Typography>
              <Typography component="li" variant="body1">その他、当サービスが本サービスの利用を適当でないと判断した場合</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第7条（免責事項）
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、当サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、当サービスに起因して利用者に生じたあらゆる損害について一切の責任を負いません。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第8条（サービス内容の変更等）
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、利用者に通知することなく、当サービスの内容を変更しまたは当サービスの提供を中止することができるものとし、これによって利用者に生じた損害について一切の責任を負いません。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第9条（利用規約の変更）
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、必要と判断した場合には、利用者に通知することなくいつでも本規約を変更することができるものとします。なお、本規約の変更後、当サービスの利用を開始した場合には、当該利用者は変更後の規約に同意したものとみなします。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              第10条（準拠法・裁判管轄）
            </Typography>
            <Typography variant="body1" paragraph>
              本規約の解釈にあたっては、日本法を準拠法とします。
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスに関して紛争が生じた場合には、当サービス運営者の所在地を管轄する裁判所を専属的合意管轄とします。
            </Typography>
          </Box>

          <Box sx={{ mt: 6, p: 3, backgroundColor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              DeckWin - カードゲームの対戦結果記録サービス
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService;